import React, {useEffect, useState} from 'react';
import { Route, Routes, useNavigate, useLocation } from "react-router-dom";
import Error404 from './components/Shared/Error404/Error404';
import FallbackComponent from './components/Shared/FallbackComponent/FallbackComponent';
import PreventedRoute from './layouts/PreventedRoute';
import ProtectedRoute from './layouts/ProtectedRoute';
import Sidebar from './components/Sidebar/Sidebar';
import routes from './routes';
import Header from './components/Header/Header';
import CommonConfig from './utils/constant';
import { useCatchResponse } from './utils/useCatchResponse';
import Loader from "./components/Shared/Loader/Loader";
import APIConstant from "./utils/pathConstants";
import api from "./utils/apiClient";
import RefreshPopup from './components/RefereshPopUp/RefereshPopUp';

function Router(props) {
    const { catchResponse } = useCatchResponse();
    const navigate = useNavigate();
    const loginData = CommonConfig.loginData('ERPLoginData');
    const location = useLocation();
    const [showRefreshPopup, setShowRefreshPopup] = useState(false);

    const fetchBuildConfiguration = async () => {
        try {
            const isLoggedIn = CommonConfig.getCookie('loggedIn');
            const userData = CommonConfig.loginData();
            if (isLoggedIn && userData?.RefreshValue) {
                setShowRefreshPopup(true);
            }
        } catch (err) {
            console.error('new build fetch error:', err);
        }
    }

    useEffect(() => {
        fetchBuildConfiguration();
    }, [fetchBuildConfiguration]);

    const handleRefresh = async () => {
        try {
            const loginData = CommonConfig.loginData();
            let data = {
                UserID: loginData?._id,
            }
            Loader.show();
            await api.post(APIConstant.path.UpdateBuildConfigurationById, data).then(async response => {
                let res = response;
                if (res.success) {
                    if (loginData) {
                        loginData.RefreshValue = false;
                        CommonConfig.setCookie('ERPLoginData', JSON.stringify(loginData));
                        CommonConfig.setCookie('refreshValue', 'false');
                        Loader.hide();
                        setShowRefreshPopup(false);
                    }
                    window.location.href = window.location.href;
                }
            }).catch(err => {
                Loader.hide();
                console.log(err);
                catchResponse(err);
            });
        } catch (error) {
            console.log('Error in handleReferesh: ', error);
            catchResponse(error);
        }
    };

    return (
        <React.Suspense fallback={<FallbackComponent />}>
            <Routes>
                {routes?.filter(x => !x.isShared).map((x, idx) => {
                    return (
                        <Route
                            key={idx}
                            path={x.path}
                            element={
                                x?.isPreventedRoute ?
                                    <PreventedRoute meta={x.meta}>
                                        <div id="main-section" className="main-section">
                                            <x.component navigate={navigate} replace={true} />
                                        </div>
                                    </PreventedRoute>
                                    :
                                    <ProtectedRoute meta={x.meta}>
                                        <div id="main-section" className='dashboard-container'>
                                            <Sidebar {...props} navigate={navigate} />
                                            <div id='dashboard-area' className='dashboard-right-side'>
                                                {/* <Header {...props} navigate={navigate} /> */}
                                                <div className='dashboard-body'>
                                                    <x.component {...props} navigate={navigate} replace={true} location={location} />
                                                </div>
                                            </div>
                                        </div>
                                    </ProtectedRoute>
                            }
                        />
                    )
                })}
                <Route path="*" element={<Error404 />} />
            </Routes>
            {(showRefreshPopup && loginData) && (
                <RefreshPopup
                    visible={showRefreshPopup}
                    onRefresh={handleRefresh}
                />
            )}
        </React.Suspense>
    )
}

export default Router;